<template>
  <div class="mt-5 mx-10 mb-10">
    <TimeFrameButtons :title="'Total Revenue'" :time-frames="['week', 'month', 'year']" :active-time-frame="this.activePeriod" @change-time-frame="changeTimeFrame"/>
    <v-progress-linear indeterminate color="blue" v-if="loading"></v-progress-linear>
    <v-card class="pa-15 mt-5">
      <apexchart ref="chart" :options="chartOptions" :series="chartOptions.series" type="bar" height="350"></apexchart>
    </v-card>
  </div>
 
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import TimeFrameButtons from '@/components/dashboard/TimeFrameButtons.vue';
import { InvoiceService } from "@/services/invoice-service.js";

export default {
  components: {
  apexchart: VueApexCharts,
  TimeFrameButtons
},
  data() {
    return {
      data : [],
      categories : [],
      activePeriod: 'week',
      loading: false,
      filter: 'week',
      chartOptions: {
        series: [
          {
            name: 'Revenue',
            data: [],
          },
        ],
        colors: ['#64B5F6'],
        chart: {
          height: 450,
          responsive: true,
          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: false,
            color: '#999',
            top: 15,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
        },
        stroke: {
          curve: 'smooth',
          width: 0,
        },
        grid: {
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: 'Revenue',
          },
        },
      },
    };
  },

  watch: {
    data: {
      handler: 'updateChart',
      deep: true,
    },
  },

  mounted() {
    this.changeTimeFrame(this.activePeriod);
  },

  methods: {
    changeTimeFrame(timeFrame) {
      this.activePeriod = timeFrame;
      this.filter = timeFrame;
      this.getRevenue();
    },

    updateChart() {
      this.$set(this.chartOptions.series, 0, { name: 'Revenue', data: this.data });
      this.chartOptions.xaxis.categories = this.categories;
      if (this.$refs.chart) {
        this.$refs.chart.updateOptions({
          xaxis: {
            categories: this.categories,
          },
          chart: {
            animations: {
              enabled: true,
              easing: 'linear',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 150
              },
              dynamicAnimation: {
                enabled: true,
                speed: 900
              },
            }
          },
        });
      }
    },

    isActive(timeFrame) {
      return this.activePeriod === timeFrame;
    },

    getRevenue() {
      this.data = [];
      this.categories = [];
      this.loading = true;
      InvoiceService.getRevenue(this.filter)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.data = response.data.data;
            this.categories = response.data.categories;
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          this.errors =  data ;
        });
    },
  },
};
</script>
